import { ApprovalConsiderationAnnounceSixContainer } from '../../../containers/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceSixContainer';
export function ApprovalConsiderationAnnounceSixPage() {
    return (
        <ApprovalConsiderationAnnounceSixContainer />
    )
}